// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 MindTenet LLC
// This file is part of Undef Engine.

interface GameTopBarProps {
  onLeaveClick: () => void;
  roomCode?: string;
  gameTitle?: string;
  currentRound?: number;
  gameIcon?: string;
}

// Map game titles to icons
const GAME_ICONS: Record<string, string> = {
  'Terrible Psychiatrist': '🧠',
  'Sick Day': '🤒',
  'Peer Review': '⭐',
};

export function GameTopBar({
  onLeaveClick,
  gameTitle = 'Terrible Psychiatrist',
  currentRound,
  gameIcon,
}: GameTopBarProps) {
  const icon = gameIcon || GAME_ICONS[gameTitle] || '🎮';

  return (
    <>
      {/* Top bar: Leave button only (connection status is in GlobalHeader) */}
      <div
        className="px-4 py-2 border-b"
        style={{
          backgroundColor: 'var(--color-surface)',
          borderColor: 'var(--color-border)',
        }}
      >
        <div className="container mx-auto max-w-6xl">
          <button
            onClick={onLeaveClick}
            className="flex items-center gap-1 px-3 py-1.5 text-sm font-bold transition-all duration-150"
            style={{
              backgroundColor: 'var(--color-surface)',
              color: 'var(--color-text-primary)',
              border: 'var(--neo-border-thin)',
              boxShadow: 'var(--neo-shadow-sm)',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.boxShadow = 'var(--neo-shadow-md)';
              e.currentTarget.style.transform = 'translate(-1px, -1px)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.boxShadow = 'var(--neo-shadow-sm)';
              e.currentTarget.style.transform = 'translate(0, 0)';
            }}
            data-testid="game-leave-button"
          >
            ← Leave
          </button>
        </div>
      </div>

      {/* Info bar: Game title + Round */}
      <div
        className="px-4 py-3 border-b text-center"
        style={{
          backgroundColor: 'var(--color-surface-hover)',
          borderColor: 'var(--color-border)',
        }}
      >
        <div className="flex items-center justify-center gap-2">
          <span className="text-xl">{icon}</span>
          <span
            className="font-display text-lg font-bold"
            style={{ color: 'var(--color-text-primary)' }}
            data-testid="game-title"
          >
            {gameTitle}
          </span>
          {currentRound !== undefined && currentRound > 0 && (
            <>
              <span style={{ color: 'var(--color-text-secondary)' }}>•</span>
              <span className="text-lg" style={{ color: 'var(--color-text-secondary)' }}>
                Round {currentRound}
              </span>
            </>
          )}
        </div>
      </div>
    </>
  );
}
